import FontAwesomeIconContainer from "../../Component/Icons/FontAwesomeIcon/FontAwesomeIcon"

const FontAwesomeIcon = () => {
  return (
    <div className='page-body'>
      <FontAwesomeIconContainer />
    </div>
  )
}

export default FontAwesomeIcon